// extracted by mini-css-extract-plugin
module.exports = {"title":"LoginPage_title__2TtpP","logo":"LoginPage_logo__1hvmw","layout":"LoginPage_layout__3tsRZ","row":"LoginPage_row__15owW"};